<template>
  <vue-drawer-layout
    ref="sidePanel"
    :drawer-width="drawerWidth"
    @slide-end="handleContentFrame"
    @slide-move="handleContentFrame"
    :content-drawable="!isMobileDevice()"
    :enable="isMobileDevice()"
    :backdrop="false"
    :z-index="0"
  >
    <div class="drawer-content" slot="drawer" style="border:1px solid white">
      <el-row :gutter="20" style="padding: 20px;">
        <el-col :md="24">
          <el-input placeholder="Όνομα, ΑΦΜ, Περιγραφή..." v-model="searchBusiness"></el-input>
        </el-col>
        <el-col :md="24">
          <r-dater v-model="dateRange"></r-dater>
        </el-col>
      </el-row>
      <el-menu
        default-active="all"
        mode="horizontal"
        @select="selectInvoiceState"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="all">Ολα</el-menu-item>

        <el-menu-item index="issed">Εκδωμενα</el-menu-item>
        <el-menu-item index="notIssued">Μη Εκδωμενα</el-menu-item>
      </el-menu>
      <s-table
        v-if="loaded"
        :topOffset="50"
        row-key-field="timologioId"
        heightWish="90%"
        :selectionId="(selectedInvoice)?selectedInvoice.timologioId:null"
        :colDefinitions="colDefinitions"
        modx-processor="timologio/getlist"
        :r-query="qInvoices"
        :rowClassFactory="invoiceListClass"
        @cell-clicked="loadInvoice"
        v-model="listedInvoices"
        ref="listedInvoices"
      ></s-table>
    </div>
    <div slot="content">
      <slot />
    </div>
  </vue-drawer-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";

export default {
  data() {
    return {
      workingBusiness: null,
      drawerIsOpen: true,
      searchBusiness: null,
      searchTransactions: null,
      invoiceState: "all",
      dateRange: [],
      listedInvoices: [],
      selectedInvoice: {},
      canEdit: true,
      aggregators: { cost: 0, costincl: 0 },
      contentFrame: "width:calc(100vw - 700px);",
      drawerWidth: 500,
      loaded: false,
      userProfile: UserProfile,
      printerLang: "gr",
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // async "selectedInvoice.businessId"(val, oldval) {
    //    _log_("ore.ssss..", val);
    //   if (val && val != oldval) {
    //     if (!this.selectedInvoice.nvoiceid) {
    //       //new
    //       const data = await api.updateProcessor(
    //         "timologio/update",
    //         this.selectedInvoice
    //       );
    //       _log_("ore...", data);
    //     }
    //   }
    // }
  },
  methods: {
    handlePayment() {
      const vm = this;
      _log_(
        "tr.!!!!!!!!!!!!!!!!!.." + this.aggregators.costincl,
        this.selectedInvoice.costwithvat,
        Math.abs(
          parseFloat(this.selectedInvoice.costwithvat) +
            parseFloat(this.workingBusiness.balance)
        )
      );
      if (
        Math.abs(
          parseFloat(this.selectedInvoice.costwithvat) +
            parseFloat(this.workingBusiness.balance)
        ) > 0.01
      )
        this.$prompt(
          "Ο συγκεκριμένος πελάτης" +
            (this.workingBusiness.balance < 0
              ? " χρωστάει "
              : " του χρωστάμε ") +
            this.$theMoney(this.workingBusiness.balance),
          "Τι λεφτά μας έδωσε;",
          {
            confirmButtonText: "Πλήρωσε το παραπάνω ποσό",
            cancelButtonText: "Ακυρω",
            inputValue: this.$theMoney(this.selectedInvoice.costwithvat),
          }
        )
          .then(({ value }) => {
            vm.selectedInvoice.payed = 1;

            vm.selectedInvoice.forcePayment = this.$theMoney(value, true);
            vm.updateInvoice();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Input canceled",
            });
          });
      // if(this.aggregators.costincl)
    },
    cancelInvoice() {
      const vm = this;
      if (this.selectedInvoice.aa && this.selectedInvoice.aa + "" != "0")
        this.$confirm(
          "Θελεις να το " +
            (vm.selectedInvoice.canceled != 1 ? "ακυρώσεις" : "επαναφερεις"),
          "ΠΡΟΣΟΧΗ!!!",
          {
            confirmButtonText: "Ναι",
            cancelButtonText: "Άστο καλήτερα",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            vm.selectedInvoice.canceled =
              vm.selectedInvoice.canceled == 1 ? 0 : 1;
            vm.updateInvoice(vm.selectedInvoice);
          })
          .catch(() => {});
    },
    invoiceListClass(k) {
      var cls = "";
      if (k.row.canceled == 1) cls += " canceled-invoice";
      if (k.row.aa > 0) cls += " issued-invoice";
      else cls += " not-issued-invoice";
      return cls;
    },
    selectInvoiceState(k) {
      this.invoiceState = k;
    },
    updateCosts(transs) {
      // _log_("tr.!!!!!!!!!!!!!!!!!..", transs);
      const vm = this;
      vm.aggregators = { cost: 0.0, costincl: 0.0 };
      transs.forEach((element) => {
        if (!isNaN(parseFloat(element.cost)))
          vm.aggregators.cost += parseFloat(element.cost);
        if (!isNaN(parseFloat(element.costincl)))
          vm.aggregators.costincl += parseFloat(element.costincl);
      });
      // _log_("tr.!!!!!!!!!!!!AA!!!!!..", vm.aggregators);
      this.selectedInvoice.cost = vm.aggregators.cost;
      this.selectedInvoice.costwithvat = vm.aggregators.costincl;
      this.updateArrayElement(
        this.listedInvoices,
        this.selectedInvoice,
        "timologioId",
        true
      );
    },
    async issueInvoice() {
      this.selectedInvoice.open = 0;
      this.selectedInvoice.editable = 0;
      const data = await this.updateInvoice();
      return data;
    },
    async updateInvoice(inv_data) {
      if (!inv_data) inv_data = this.selectedInvoice;
      if (!inv_data) return;
      const data = await api.updateProcessor("timologio/update", inv_data);
      this.selectedInvoice = data;
      _log_("inv is...", this.selectedInvoice);
      this.updateArrayElement(
        this.listedInvoices,
        this.selectedInvoice,
        "timologioId",
        true
      );
      return data;
    },
    newInvoice() {
      this.canEdit = true;
      this.selectedInvoice = {
        timologioId: null,
        editable: 1,
        aa: 0,
        open: 1,
        date: format(new Date(), "DD/MM/YYYY"),
        vat: 24,
        place: "Ζακυνθος",
      };
      this.listedInvoices.unshift(this.selectedInvoice);
      // this.$refs.listedInvoices.appendRecord(this.selectedInvoice)
    },
    toggleDrawer(v) {
      this.$refs.sidePanel.toggle(v);
    },
    async changeBusiness(e) {
      this.workingBusiness = e;
      // _log_("hell..ccc.", e);
      if (this.selectedInvoice.businessId != e.businessId) {
        this.selectedInvoice.businessId = e.businessId;
        this.updateInvoice();
      } else {
        this.selectedInvoice.business_name = e.name;
        this.selectedInvoice.business_afm = e.afm;
        this.selectedInvoice.business_alias = e.alias;
      }
      // if (this.selectedInvoice.nvoiceid) {
      //new

      // this.$refs.updateInvoices.appendRecord(this.selectedInvoice)

      // }
      // e=>(selectedInvoice.businessId=e.businessId)
    },
    handleContentFrame(pix) {
      if (this.isMobileDevice()) {
        this.contentFrame = "width:100vw;";
        return;
      }
      if (pix === true) {
        this.drawerIsOpen = pix;
        pix = this.drawerWidth;
      }
      if (pix === false) {
        this.drawerIsOpen = pix;
        pix = 0;
      }
      // pix=700
      if (_.isNumber(pix))
        this.contentFrame = "width:calc(100vw - " + (pix + 3) + "px);";
    },

    loadInvoice(d) {
      _log_("hell..ss.", d.row);
      this.canEdit = !d.row.aa || d.row.aa + "" == "0" || d.row.aa + "" == "";
      this.selectedInvoice = d.row;
    },

    alert(msg) {
      _log_("hell...", msg);
    },
    setRange(dateOne, dateTwo) {
      this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
    },
    formatDates() {
      const dateOne = this.qRange[0],
        dateTwo = this.qRange[1];
      // this.qRange = [new Date(dateOne).getTime(), new Date(dateTwo).getTime()];
      let formattedDates = "";
      if (dateOne && dateOne != "") {
        formattedDates = format(new Date(dateOne), this.dateFormat);
      }
      if (dateTwo && dateTwo != "") {
        formattedDates += " - " + format(new Date(dateTwo), this.dateFormat);
      }
      return formattedDates;
    },
    // zoom() {
    //   this.$refs.stimeline.zoom();
    // },
    newBooking() {
      // _log_("gooooo");
      this.routeGo({
        name: "EditBooking",
        query: { bkid: "new" },
      });
    },
    // ...mapActions({
    //   fetchRooms: "hotelinfo/fetchRooms"
    // }),

    goToInvoice(data) {
      _log_("bokk,,,", data);
      window.open(
        "/invoices/&invoiceid=" +
          data.row.inv_timologioId +
          "&sira=" +
          data.row.inv_kind +
          "&timo_group=" +
          data.row.inv_timo_group,
        "_blank"
      );
      // this.routeGo({
      //   name: "EditBooking",
      //   query: { bkid: data.row.idBooking }
      // });
    },
  },
  async mounted() {
    const date = new Date();
    this.qRange = [date.getTime(), date.getTime() + 3600 * 1000 * 24 * 91];
    this.toggleDrawer(true);
    if (window.innerWidth > 901) this.heightWish = "50%";
    else this.heightWish = "50%";
    if (this.isMobileDevice()) this.heightWish = "100%";
    this.loaded = true;
    // _log_("the rs///", this.userProfile);
  },
  computed: {
    printLink() {
      var urlprfx = "";
      if (this.workingBusiness && this.workingBusiness.externalLinkId) {
        var prfx = this.workingBusiness.externalLinkId.split("printer:");
        if (prfx[1] && prfx[1] != "") urlprfx = prfx[1] + "-";
      }
      var l = urlprfx + this.userProfile.printer_link;
      l +=
        "&pdf=full&objectId=" +
        this.selectedInvoice.timologioId +
        "&headerHeight=51&objectClass=Timologio&action=view&printmode=" +
        this.printerLang;
      return l;
      //"printerPrfx()+'[[!~[[!+printer:getPrinter]]]]&pdf=full&objectId='+Timologio.timologioId+'&headerHeight=51&objectClass=Timologio&action=view&printmode='+Lang"
    },
    range: {
      set(range) {
        this.$store.commit("dateRange", range);
      },
      get(range) {
        return this.$store.state.dateRange;
      },
    },
    qInvoices() {
      return {
        sort: "date",
        dir: "DESC",
        sira: "invoice",
        issue_state: this.invoiceState,
        timo_group: "Α",
        search: this.searchBusiness,
        searchdaterange:
          this.dateRange && this.dateRange.length
            ? this.dateRange[0] + "-" + this.dateRange[1]
            : null,
      };
    },

    colDefinitions() {
      return [
        {
          prop: "aa",
          width: "",
          label: "Α.Α.",
          formatter(val, colDefs, row) {
            if (val == 0) return "";
            return (
              '<span class="el-tag el-tag--' +
              (row.canceled == 1 ? "danger" : "success") +
              ' el-tag--light">' +
              val +
              "</span>" +
              (row.payed ? '<i class="material-icons">thumb_up</i>' : "")
            );
          },
        },
        { prop: "date", width: "", label: "Ημ/νια" },
        { prop: "business_name", width: "", label: "Πελατης" },

        {
          prop: "cost",
          width: "",
          label: "Κοστος",
          formatter(val, colDefs, row) {
            if (val) return parseFloat(val).formatMoney(2) + "&euro;";
            return "-";
          },
        },

        {
          prop: "costwithvat",
          width: "",
          label: "Με ΦΠΑ",
          formatter(val, colDefs, row) {
            if (val) return parseFloat(val).formatMoney(2) + "&euro;";
            return "-";
          },
        },
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.title {
  color: aliceblue;
  text-align: center;
}
.has-more {
  color: red;
  font-weight: 700;
}
</style>
